import axios from "axios"
import createAuthRefreshInterceptor from "axios-auth-refresh"
import { notification } from "antd"
import { getAuthLocal, setAuthLocal, removeAuthLocal } from "../lib/localstorage"

const API_BASE =
  process.env.REACT_APP_DOMAIN ||
  (process.env.REACT_APP_API_DOMAIN ? `${process.env.REACT_APP_API_DOMAIN.replace(/\/$/, "")}/` : "/api/v1/")
const REFRESH_URL = `${API_BASE}internal/token/refresh/`

const refreshAuthLogic = (failedRequest) =>
  axios
    .post(REFRESH_URL, {
      // SimpleJWT TokenRefreshSerializer expect field name: `refresh`
      refresh: getAuthLocal()?.refresh,
    })
    .then((tokenRefreshResponse) => {
      const data = tokenRefreshResponse?.data ?? tokenRefreshResponse
      // Backend SimpleJWT trả về trường `access` (hoặc `token` nếu đã custom)
      const newAccess = data.token || data.access
      if (!newAccess) {
        return Promise.reject(new Error("Missing access token from refresh response"))
      }
      // Cập nhật header cho request đang bị 401
      failedRequest.response.config.headers.Authorization = `Bearer ${newAccess}`
      // Lưu lại vào localStorage để các request sau dùng token mới
      const current = getAuthLocal() || {}
      setAuthLocal({ ...current, token: newAccess })
      return Promise.resolve()
    })
    .catch(() => {
      const auth = getAuthLocal()
      // Nếu chưa có refresh (hoặc đang ở màn login) thì không redirect vòng lặp, chỉ coi như request thất bại
      const onLoginPage = typeof window !== "undefined" && window.location.pathname === "/login"
      if (!auth?.refresh || onLoginPage) {
        return Promise.reject()
      }
      removeAuthLocal()
      if (typeof window !== "undefined") {
        window.location.href = "/login"
      }
      return Promise.reject()
    })

export default function getInstanceAxios(baseAPI) {
  const instance = axios.create({
    baseURL: baseAPI
  })

  instance.interceptors.request.use(
    function (config) {
      config.headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: getAuthLocal()?.token ? `Bearer ${getAuthLocal()?.token}` : undefined
      }
      return config
    },
    function (error) {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use(
    function (response) {
      if (response.status >= 200 && response.status < 300) return response.data
      return Promise.reject(response.data)
    },
    function (error) {
      if (error.response) {
        const { response } = error
        const data = response?.data
        const method = (response.config?.method || "").toLowerCase()
        if (data && response.status !== 500) {
          const rawMsg =
            typeof data === "object" && data !== null
              ? data.message || data.error_message || data.detail
              : typeof data === "string"
                ? data
                : null
          const msg = rawMsg != null && String(rawMsg).trim() !== "" ? String(rawMsg) : "Có lỗi xảy ra"
          const showForGet = method === "get" && [400, 403, 404].includes(response.status)
          if (method !== "get" || showForGet) {
            notification.error({ message: msg })
          }
        }
      }
      return Promise.reject(error)
    }
  )

  createAuthRefreshInterceptor(instance, refreshAuthLogic)
  return instance
}
